import { Game, GameTag } from "entities/game/types";
import { ServicePrimaryTag } from "entities/tagTypes/types";
import { Dispatch, SetStateAction } from "react";
import { Translations } from "shared/types/languages";

export type GameFile = File | null;

export type GameDetailsType = {
  imageLoadingStatus: {
    isBgImageLoaded: boolean;
    isLogoImageLoaded: boolean;
  };
  tab: GameTabsEnum;
  gameDetails?: Game | null;
  setTab: Dispatch<SetStateAction<GameTabsEnum>>;
  backgroundFile: GameFile;
  setBackgroundFile: Dispatch<SetStateAction<GameFile>>;
  logoFile: GameFile;
  setLogoFile: Dispatch<SetStateAction<GameFile>>;
  translations?: Translations;
  setTranslations: Dispatch<SetStateAction<Translations | undefined>>;
  onSaveGameDetails: () => void;
  onSaveGameTranslations: () => void;
  isSubmittingGame: boolean;
  onCloseDrawer: () => void;
  servicePrimaryTags?: ServicePrimaryTag[];
};

export type TagTypeBlock = {
  id: string;
  tagCategory: string;
  selectedTags: GameTag[];
};

export enum GameTabsEnum {
  GENERAL,
  IMAGES,
  TAGS,
  TRANSLATIONS,
  METADATA,
}

export enum GameMetadataTabsEnum {
  GENERAL = "General",
  GAME_INFORMATION = "Game information",
}
